import {Document, Page, View, Font, Text} from "@react-pdf/renderer";

import RubikLight from "../../../../fonts/Rubik-Light.ttf";
import RubikRegular from "../../../../fonts/Rubik-Regular.ttf";
import RubikMedium from "../../../../fonts/Rubik-Medium.ttf";
import RubikBold from "../../../../fonts/Rubik-Bold.ttf";
import RubikBlack from "../../../../fonts/Rubik-Black.ttf";

import {styles} from "./StylesPDFSchoolReport";
import CoverPage from "./pdf/Cover";
import React from "react";
import Section1 from "./pdf/Section1";
import Section2 from "./pdf/Section2";
import Section31 from "./pdf/Section31";
import Section32 from "./pdf/Section32";
import Section33 from "./pdf/Section33";

Font.register({
    family: "Rubik",
    format: "truetype",
    fonts: [
        { src: RubikLight, fontWeight: 300 },
        { src: RubikRegular, fontWeight: 400 },
        { src: RubikMedium, fontWeight: 500 },
        { src: RubikBold, fontWeight: 700 },
        { src: RubikBlack, fontWeight: 800 },
    ],
});

Font.registerHyphenationCallback(word => [word]);

type ReportProps = {
    data: any;          // replace any with your real type if possible
    images: any[];
    schoolName: string;
};

const Report = ({data, images, schoolName}: any) => {
    const table4 = data.payload.table4.map((item: any) => ({
        dimensions: `Scor total clasa ${item.grade}`,
        ...item,
    }));

    const table5 = data.payload.table5.map((item: any) => ({
        dimensions: `Scor total clasa ${item.grade}`,
        ...item,
    }));

    const table8 = data.payload.table8.map((item: any) => ({
        dimensions: `Scor total clasa ${item.grade}`,
        ...item,
    }));

    // Precompute image groups once
    const [imageBoxplot, imageHeatmap, imageRiscHeatmap] = images;

    const gradeBoxplots = images.filter((item: any) =>
        item.id.includes("gradeBoxplot")
    );
    const gradeHeatmaps = images.filter((item: any) =>
        item.id.includes("gradeHeatmap")
    );
    const gradeRiscHeatmaps = images.filter((item: any) =>
        item.id.includes("gradeRiscHeatmap")
    );

    return (
        <Document>
            <Page wrap size="A4" style={styles.body}>
                <View style={styles.coverBg}>
                    <CoverPage
                        startDate={data.start_date}
                        endDate={data.end_date}
                        subject={data.subject}
                        schoolName={schoolName}
                        tag={data.tag}
                    />
                    <View style={styles.mb100}></View>
                    <View style={styles.wrapperCover}>
                        <Section1
                            table2={data.payload.table2}
                            subject={data.subject}
                            totalTests={data.payload.finished_tests_count}
                        />
                        <View style={styles.mb100}></View>
                        <Section2
                            subject={data.subject}
                            imageBoxplot={imageBoxplot?.image}
                            imageHeatmap={imageHeatmap?.image}
                            imageRiscHeatmap={imageRiscHeatmap?.image}
                            table4={table4}
                            table5={table5}
                            table8={table8}
                        />
                        <View style={styles.mb100}></View>
                        <View style={styles.sectionAbout}>
                            <Text style={[styles.h1, styles.mb13]}>SECȚIUNEA 3. Rezultate privind competențele măsurate, pentru fiecare clasă</Text>
                            <Text style={styles.h1subtitle}>3.1. Scoruri medii și distribuții pentru fiecare clasa</Text>
                            <Section31
                                table6={data.payload.table6}
                                subject={data.subject}
                                imagesBoxplot={gradeBoxplots}
                            />
                            <View style={styles.mb13}></View>
                            <Text style={styles.h1subtitle}>3.2. Distribuția elevilor în categorii decile naționale pentru fecare clasa</Text>
                            <Section32
                                table7={data.payload.table7}
                                subject={data.subject}
                                imagesHeatmap={gradeHeatmaps}
                            />
                            <View style={styles.mb13}></View>
                            <Text style={styles.h1subtitle}>3.3. Distribuția elevilor în categorii de risc pentru fiecare clasa</Text>
                            <Section33
                                table9={data.payload.table9}
                                subject={data.subject}
                                imagesHeatmap={gradeRiscHeatmaps}
                            />
                            <View style={styles.mb13}></View>
                        </View>
                        {/*<View break>*/}
                        {/*    <Text style={styles.tableNoteNumber}>1</Text>*/}
                        {/*</View>*/}
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default Report;
